import React from 'react'
import {Helmet} from 'react-helmet-async'
import * as c from '../const'

const RHelmet = (
  {
    title = c.DEFAULT_SEO.title,
    description = c.DEFAULT_SEO.description,
    keywords = c.DEFAULT_SEO.keywords,
    url = c.DEFAULT_SEO.url,
    siteName = c.DEFAULT_SEO.siteName,
    img = c.DEFAULT_SEO.img
  }
) => {
  const seoTitle = title + c.SEO_TITLE_SUFFIX

  return (
    <Helmet>
      <title>{seoTitle}</title>
      <meta property={`og:title`} content={seoTitle}/>
      <meta name={`twitter:title`} content={seoTitle}/>
      <meta name={`description`} content={description}/>
      <meta property={`og:description`} content={description}/>
      <meta name={`twitter:description`} content={description}/>
      <meta name={`keywords`} content={keywords}/>
      <meta property={`og:type`} content={`object`}/>
      <meta property={`og:url`} content={url}/>
      <meta property={`og:site_name`} content={siteName}/>
      <meta property={`og:image`} content={img}/>
      <meta property={`og:image:width`} content={`240`}/>
      <meta property={`og:image:height`} content={`240`}/>
      <meta name={`twitter:card`} content={`summary_large_image`}/>
      <meta name={`twitter:image`} content={img}/>
    </Helmet>
  )
}

export default RHelmet
